var $4ea0bcdb245497b6$exports = {};
$4ea0bcdb245497b6$exports = {
    "loading": `Laden...`,
    "loadingMore": `Meer laden...`
};


export {$4ea0bcdb245497b6$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
